module.exports = __webpack_public_path__ + "static/media/logosat.a46608ed.svg";